import React from "react"
import PropTypes from "prop-types"
import s from "./RouteFallback.module.scss"

/**
 * Suspense fallback for lazily-loaded routes.
 *
 * Every route in this app is `lazy()`, and the router used to pass
 * `fallback={null}` — so switching modules rendered *nothing* until the chunk
 * downloaded, which read as the app blanking out. This gives that gap a
 * visible state instead.
 */
const RouteFallback = ({ label = "Loading…" }) => (
  <div className={s.wrap} role="status" aria-live="polite">
    <span className={s.spinner} aria-hidden="true" />
    <span>{label}</span>
  </div>
)

RouteFallback.propTypes = {
  label: PropTypes.string
}

export default RouteFallback
